module.exports = __webpack_public_path__ + "img/InsuranceLimitations.fc391c3e.svg";